<template>
  <div class="operation-wrap">
    <WechatLogin
      v-if="status === 'login' && loginMode === 'wechat'"
      @success="$emit('next')"
      @accountSelect="onSelectAccount"
      @switch="onChangeLoginModeClick"
    ></WechatLogin>
    <AccountLogin
      v-if="status === 'login' && loginMode === 'pwd'"
      @back="status = 'resetPwd'"
      @success="$emit('next')"
      @accountSelect="onSelectAccount"
      @switch="onChangeLoginModeClick"
    />
    <SelectAccount v-model:open="open" @select="onSelect" />
    <AccountResetPwd v-if="status === 'resetPwd'" @back="status = 'login'" />
    <TasteAccountHint v-model:open="tasteAccountListOpen" :accounts="tasteAccounts">
      <div class="flex justify-center mt-[16px]">
        <a-button class="w-[368px]" type="primary" @click="switchAccount">
          {{ $t('qie-huan-zhang-hao') }}
        </a-button>
      </div>
    </TasteAccountHint>
  </div>
</template>
<script lang="ts" setup>
import { USER_LEVEL_KEY, type LoginInfo } from '~/api/interface';
import { USER_ADMIN } from '~/constants';
import SelectAccount from '~/features/account/select/selectModal.vue';
import TasteAccountHint from '~/features/tasteAccountHint/index.vue';
import AccountLogin from '~/pages/login/features/login-form/ui/Base.vue';
import WechatLogin from '~/pages/login/features/login-form/ui/LoginWechat.vue';
import AccountResetPwd from '~/pages/login/features/reset-password/index.vue';
import { isChinese } from '~/utils/area';
import { emitter, EVENT } from '~/utils/eventbus';

type Status = 'login' | 'resetPwd';

const emit = defineEmits(['next']);

const loginModeTooltip = computed(() => {
  return loginMode.value === 'pwd' ? '微信登录' : '手机号/账号登录'; // @xi18n-ignore
});

// 登录方式
type LoginMode = 'pwd' | 'wechat';

const loginMode = ref<LoginMode>(isChinese() ? 'wechat' : 'pwd');

function onChangeLoginModeClick() {
  loginMode.value = loginMode.value === 'pwd' ? 'wechat' : 'pwd';
}

const status = ref<Status>('login');

onMounted(() => {
  emitter.on(EVENT.SWITCH_WECHAT_LOGIN, () => (loginMode.value = 'wechat'));
  emitter.on(EVENT.FIND_PWD, () => (status.value = 'resetPwd'));
});

const open = ref(false);
const tasteAccountListOpen = ref(false);

const tasteAccounts = ref<LoginInfo[]>([]);

let accountSelectToNext = true;

function onSelectAccount(loginInfos: LoginInfo[]) {
  accountSelectToNext = true;
  // 如果有体验版账号
  tasteAccounts.value = loginInfos.filter(item => {
    return (
      Number(item.rights_type) === USER_LEVEL_KEY.TEAM_TASTE &&
      Number(item.permission) !== USER_ADMIN.NORMAL
    );
  });

  if (tasteAccounts.value.length > 0) {
    tasteAccountListOpen.value = true;
    return;
  }

  open.value = true;
}

// 账号选择后，进入下一步

const router = useRouter();
const homeRoute = useHomeRoute();

function onSelect() {
  if (accountSelectToNext) {
    emit('next');
    open.value = false;
  } else {
    router.push(homeRoute);
  }
}

function switchAccount() {
  accountSelectToNext = false;
  tasteAccountListOpen.value = false;
  open.value = true;
}
</script>
<style lang="scss" scoped>
.operation-wrap {
  position: relative;
  padding: 70px 90px 40px;
  display: flex;
  justify-content: center;
  width: 600px;
  background: var(--login-operation-bg);
  border-radius: 20px;
  border: 1px solid var(--back-3);
}
.login-mode-switcher {
  position: absolute;
  right: 0;
  top: 0;
  width: 79px;
  height: 76px;
  cursor: pointer;

  &::after,
  &::before {
    position: absolute;
    content: ' ';
    width: 0;
    height: 0;
    right: 0;
    bottom: 0;
  }
  &::after {
    // 左下角白色三角形
    border-top: 76px solid transparent;
    border-right: 0 solid transparent;
    border-left: 79px solid var(--login-operation-bg);
    pointer-events: none;
  }
  &::before {
    // 右上角蓝色三角形
    border-bottom: 76px solid transparent;
    border-left: 0 solid transparent;
    border-right: 79px solid var(--purple-1);
  }
  iconpark-icon {
    position: absolute;
    font-size: 27px;
    color: var(--primary-color);
    right: 15px;
    top: 15px;
  }
}
</style>
